const updatePrefix = (data: string) => `THEME/${data}`;

export const UPDATE_THEME_DATA = updatePrefix("UPDATE_THEME_DATA");

export const FETCH_THEME_DATA = updatePrefix("FETCH_THEME_DATA");
export const FETCH_THEME_DATA_SUCESS = updatePrefix("FETCH_THEME_DATA_SUCCESS");
export const FETCH_THEME_DATA_FAILURE = updatePrefix(
  "FETCH_THEME_DATA_FAILURE"
);
export const SET_THEME_DATA = updatePrefix("SET_THEME_DATA");

export const SAVE_THEME_DATA = updatePrefix("SAVE_THEME_DATA");

export const GET_THEME_DATA = updatePrefix("GET_THEME_DATA");
export const GET_ALL_THEME_DATA = updatePrefix("GET_ALL_THEME_DATA");
export const GET_ALL_THEME_DATA_SUCCESS = updatePrefix(
  "GET_ALL_THEME_DATA_SUCCESS"
);
export const GET_ALL_THEME_DATA_FAILURE = updatePrefix(
  "GET_ALL_THEME_DATA_FAILURE"
);

export const UPDATE_THEME_DATA_SUCCESS = updatePrefix(
  "UPDATE_THEME_DATA_SUCCESS"
);
export const UPDATE_THEME_DATA_FAILURE = updatePrefix(
  "UPDATE_THEME_DATA_FAILURE"
);
export const FETCH_ACTIVE_THEME_ID = updatePrefix("FETCH_ACTIVE_THEME_ID");
export const RESET_THEME_DATA = updatePrefix("RESET_THEME_DATA");
export const DELETE_THEME_DATA = updatePrefix("DELETE_THEME_DATA");
export const UPDATE_THEME_ERROR = updatePrefix("UPDATE_THEME_ERROR");
export const UPDATE_FETCH_THEME_LOADER = updatePrefix(
  "UPDATE_FETCH_THEME_LOADER"
);
